(function () {
    var MOBILE_QUERY = '(max-width: 1024px)';
    var FOCUSABLE_SELECTOR = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    function initHeaderMenu(header) {
        var media = window.matchMedia(MOBILE_QUERY);
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        var toggle = header.querySelector('[data-mobile-menu-toggle]');
        var panel = header.querySelector('[data-mobile-menu-panel]');
        var closeButtons = header.querySelectorAll('[data-mobile-menu-close]');
        var submenuItems = Array.prototype.slice.call(
            header.querySelectorAll('.header__menu-item--has-children')
        );
        var isOpen = false;
        var lastFocused = null;

        if (!toggle || !panel) return;

        function finishSubmenuAnimation(submenu, expanded) {
            submenu.style.removeProperty('overflow');
            submenu._headerMenuAnimation = null;
            submenu.hidden = !expanded;
        }

        function animateSubmenu(submenu, expanded) {
            var startHeight = submenu.hidden
                ? 0
                : submenu.getBoundingClientRect().height;
            var startOpacity = submenu.hidden
                ? 0
                : parseFloat(window.getComputedStyle(submenu).opacity) || 0;

            if (submenu._headerMenuAnimation) {
                submenu._headerMenuAnimation.cancel();
            }

            submenu.hidden = false;
            submenu.style.overflow = 'hidden';

            var animation = submenu.animate([
                {
                    height: startHeight + 'px',
                    opacity: startOpacity
                },
                {
                    height: expanded ? submenu.scrollHeight + 'px' : '0px',
                    opacity: expanded ? 1 : 0
                }
            ], {
                duration: 300,
                easing: 'cubic-bezier(0.22, 1, 0.36, 1)'
            });

            submenu._headerMenuAnimation = animation;
            animation.addEventListener('finish', function () {
                if (submenu._headerMenuAnimation !== animation) return;
                finishSubmenuAnimation(submenu, expanded);
            });
        }

        function setSubmenuState(item, expanded, shouldAnimate) {
            var button = item.querySelector(
                ':scope > .header__submenu-toggle, :scope > .header__menu-toggle'
            );
            var submenu = item.querySelector(':scope > .header__submenu');

            if (!button || !submenu) return;

            item.classList.toggle('is-submenu-open', expanded);
            button.setAttribute('aria-expanded', expanded ? 'true' : 'false');

            if (button.dataset.labelOpen && button.dataset.labelClose) {
                button.setAttribute(
                    'aria-label',
                    expanded ? button.dataset.labelClose : button.dataset.labelOpen
                );
            }

            if (media.matches && !item.classList.contains('header__menu-item--button-parent')) {
                submenu.toggleAttribute('inert', !expanded);

                if (
                    shouldAnimate
                    && !reducedMotion.matches
                    && typeof submenu.animate === 'function'
                ) {
                    animateSubmenu(submenu, expanded);
                } else {
                    if (submenu._headerMenuAnimation) {
                        submenu._headerMenuAnimation.cancel();
                    }
                    finishSubmenuAnimation(submenu, expanded);
                }
            } else {
                submenu.removeAttribute('inert');
                submenu.hidden = false;
            }
        }

        function resetSubmenus() {
            submenuItems.forEach(function (item) {
                var isFlattened = item.classList.contains('header__menu-item--button-parent');
                var isCurrent = item.classList.contains('header__menu-item--active-child')
                    || item.classList.contains('header__menu-item--current');

                if (media.matches) {
                    setSubmenuState(item, isFlattened || isCurrent, false);
                } else {
                    setSubmenuState(item, false, false);
                }
            });
        }

        function setPanelAccessibility(open) {
            if (!media.matches) {
                panel.removeAttribute('aria-hidden');
                panel.removeAttribute('inert');
                return;
            }

            panel.setAttribute('aria-hidden', open ? 'false' : 'true');

            if (open) {
                panel.removeAttribute('inert');
            } else {
                panel.setAttribute('inert', '');
            }
        }

        function openMenu() {
            if (!media.matches || isOpen) return;

            isOpen = true;
            lastFocused = document.activeElement;
            header.classList.add('is-menu-open');
            document.documentElement.classList.add('mobile-menu-open');
            toggle.setAttribute('aria-expanded', 'true');
            toggle.setAttribute('aria-label', 'Закрити меню');
            setPanelAccessibility(true);
        }

        function closeMenu(restoreFocus) {
            if (!isOpen && media.matches) {
                setPanelAccessibility(false);
                return;
            }

            isOpen = false;
            header.classList.remove('is-menu-open');
            document.documentElement.classList.remove('mobile-menu-open');
            toggle.setAttribute('aria-expanded', 'false');
            toggle.setAttribute('aria-label', 'Відкрити меню');
            setPanelAccessibility(false);

            if (restoreFocus && lastFocused && typeof lastFocused.focus === 'function') {
                lastFocused.focus();
            }
        }

        function getFocusableElements() {
            return Array.prototype.slice.call(
                panel.querySelectorAll(FOCUSABLE_SELECTOR)
            ).filter(function (element) {
                return !element.hasAttribute('disabled')
                    && element.getAttribute('aria-hidden') !== 'true'
                    && (element.offsetWidth > 0 || element.offsetHeight > 0);
            });
        }

        function trapFocus(event) {
            if (!isOpen || event.key !== 'Tab') return;

            var focusable = getFocusableElements();
            if (!focusable.length) return;

            var first = focusable[0];
            var last = focusable[focusable.length - 1];

            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        }

        function applyMode() {
            if (media.matches) {
                resetSubmenus();
                closeMenu(false);
            } else {
                closeMenu(false);
                resetSubmenus();
                setPanelAccessibility(false);
            }
        }

        toggle.addEventListener('click', function () {
            if (isOpen) {
                closeMenu(true);
            } else {
                openMenu();
            }
        });

        closeButtons.forEach(function (closeButton) {
            closeButton.addEventListener('click', function () {
                closeMenu(true);
            });
        });

        submenuItems.forEach(function (item) {
            var button = item.querySelector(
                ':scope > .header__submenu-toggle, :scope > .header__menu-toggle'
            );

            if (!button) return;

            button.addEventListener('click', function () {
                if (
                    media.matches
                    && item.classList.contains('header__menu-item--button-parent')
                ) {
                    return;
                }

                var willOpen = button.getAttribute('aria-expanded') !== 'true';

                if (willOpen) {
                    item.classList.remove('is-submenu-click-closed');
                }

                if (media.matches && willOpen) {
                    submenuItems.forEach(function (otherItem) {
                        var otherButton = otherItem.querySelector(
                            ':scope > .header__submenu-toggle, :scope > .header__menu-toggle'
                        );

                        if (
                            otherItem !== item
                            && otherItem.parentElement === item.parentElement
                            && !otherItem.classList.contains('header__menu-item--button-parent')
                            && otherButton
                            && otherButton.getAttribute('aria-expanded') === 'true'
                        ) {
                            setSubmenuState(otherItem, false, true);
                        }
                    });
                }

                setSubmenuState(item, willOpen, true);

                if (!willOpen) {
                    item.classList.add('is-submenu-click-closed');
                }
            });

            item.addEventListener('mouseenter', function () {
                item.classList.remove('is-submenu-click-closed');
            });
        });

        panel.addEventListener('click', function (event) {
            var link = event.target.closest('a[href]');
            var modalTrigger = event.target.closest('[data-modal-open]');

            if (modalTrigger) {
                window.setTimeout(function () {
                    closeMenu(false);
                }, 0);
            } else if (link) {
                closeMenu(false);
            }
        });

        document.addEventListener('click', function (event) {
            if (media.matches || header.contains(event.target)) return;

            submenuItems.forEach(function (item) {
                setSubmenuState(item, false);
            });
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                if (isOpen) {
                    event.preventDefault();
                    closeMenu(true);
                } else if (!media.matches) {
                    submenuItems.forEach(function (item) {
                        setSubmenuState(item, false);
                    });
                }
            }

            trapFocus(event);
        });

        if (typeof media.addEventListener === 'function') {
            media.addEventListener('change', applyMode);
        } else {
            media.addListener(applyMode);
        }

        applyMode();
    }

    function init() {
        document.querySelectorAll('[data-mobile-menu]').forEach(initHeaderMenu);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
